import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css'; // Assuming legal-page styles are here

const RefundPolicyPage = () => {
  return (
    <div className="legal-page">
      <div className="back-link-container">
        <Link to="/" className="back-link">← Back to Home</Link>
      </div>
      <h1>Refund Policy</h1>
      <p><strong>Last Updated: [Date]</strong></p>

      <p>
        Thank you for using Magical Videos!
      </p>
      <p>
        If, for any reason, You are not completely satisfied with a purchase 
        We invite You to review our policy on refunds. The following terms 
        are applicable for any products or services that You purchased with Us.
      </p>

      <h2>Conditions for Refund</h2>
      <p>
        In order to be eligible for a refund, you have to [State conditions, e.g., 
        report the issue within X days of purchase, demonstrate the service did not 
        perform as described, etc.].
      </p>
      <p>
        [Explain situations where refunds are NOT granted, e.g., exceeding usage limits, 
        change of mind after successful generation, etc.]
      </p>

      <h2>How to Request a Refund</h2>
      <p>
        To request a refund, please contact our support team at [Your Support Email] 
        with your order details and a clear explanation of the issue. ...
      </p>

      {/* Add more sections if needed: Processing Time, Contact, etc. */}
      <h2>Contact Us</h2>
      <p>
        If you have any questions about our Refunds Policy, please contact us:
        [Your Contact Email/Info]
      </p>
    </div>
  );
};

export default RefundPolicyPage; 